import { RackZoneMappingDTo } from "@gtpl/shared-models/masters";
import { EndCustomers } from "../end-customer/end-customer.entity";
import { Rack } from "../racks/racks.entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";
import { RackZoneMappingDtO } from "./dto/rack-zone-mapping-dto";
import { RackZoneMapping } from "./rack-zone-mapping-entity";


export class RackZoneMappingAdapter {

    public convertDtoToEntity(details: RackZoneMappingDtO,isUpdate:boolean): RackZoneMapping {
        const rackzonemapping = new RackZoneMapping();
        if (details.rackZoneMappingId) {
            rackzonemapping.rackZoneMappingId = details.rackZoneMappingId;
        }
        rackzonemapping.rackInfo = new Rack();
        rackzonemapping.rackInfo.rackId = details.rackId;
        rackzonemapping.zoneInfo = new ZoneMaster();
        rackzonemapping.zoneInfo.zoneId = details.zoneId;
        rackzonemapping.endCustomerInfo = new EndCustomers();
        rackzonemapping.endCustomerInfo.endCustomerId = details.endCustomerId;
        if (isUpdate) {
            rackzonemapping.updatedUser = details.updatedUser;
          } else {
            rackzonemapping.isActive = true;
            rackzonemapping.createdUser = details.createdUser;
          }
        return rackzonemapping;
    }

    public convertEntityToDto(details:RackZoneMapping) : RackZoneMappingDtO {
      const qualificationDTO= new RackZoneMappingDtO;
  qualificationDTO.rackZoneMappingId = details.rackZoneMappingId;
  qualificationDTO.rackId = details.rackId;
  qualificationDTO.zoneId = details.zoneId;
  qualificationDTO.endCustomerId = details.endCustomerId;
  qualificationDTO.isActive = details.isActive;
  // qualificationDTO.createdAt = details.createdAt;
  // qualificationDTO.updatedAt = details.updatedAt;
  qualificationDTO.createdUser = details.createdUser;
  qualificationDTO.updatedUser = details.updatedUser;
  // qualificationDTO.versionFlag = details.versionFlag;
  return qualificationDTO; 
  }

}